import { render, staticRenderFns } from "./CoTimeToolUserCaptcha.vue?vue&type=template&id=64720ae0&scoped=true&"
import script from "./CoTimeToolUserCaptcha.vue?vue&type=script&lang=js&"
export * from "./CoTimeToolUserCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./CoTimeToolUserCaptcha.vue?vue&type=style&index=0&id=64720ae0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64720ae0",
  null
  
)

export default component.exports